module.exports = __webpack_public_path__ + "static/profile-pic-e274692c95be974e6dc66a8b9343de64.jpg";